import { autoinject } from 'aurelia-framework';
import { State } from '../../services/global-state';
import { I18N } from 'aurelia-i18n';

@autoinject
export class Bulletin {
	constructor(private globalState: State,
		private i18n: I18N) { }

	get isBulletinVisible() {
		try {
			let portalDashboardBulletinContent = this.i18n.i18next.t('portalDashboardBulletinContent', '');
			return this.globalState.business.portalSettings.enableConsumerPortalDashboardBulletin
				&& portalDashboardBulletinContent.length;
		} catch (e) {
			return false;
		}
	}
}
